import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface BotState {
    name: string;
    online: boolean;
}

const initialState: BotState = {
    name: "MeetMyBot",
    online: true,
};

const botSlice = createSlice({
    name: "bot",
    initialState,
    reducers: {
        setName(state, action: PayloadAction<string>) {
            state.name = action.payload;
        },
        setOnline(state, action: PayloadAction<boolean>) {
            state.online = action.payload;
        },
    },
});

export const { setName, setOnline } = botSlice.actions;
export default botSlice.reducer;
